import React from "react";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../../../../core/constants/svgs";
import useIsMobile from "../../../../../../core/hooks/useMobile";
import editIcon from "../../../../../../assets/png/edit.png";

const AccordionSection = ({
  id,
  title,
  content,
  handleAccordion,
  editMode = false,
  onEditToggle = null,
  onSave = null,
  onContentChange = null,
  addTopSpacing = false,
  saveLabel = null,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div
      id={"container-" + id}
      style={{ paddingTop: addTopSpacing ? "1rem" : "0" }}
    >
      <div className="chapter-item-container">
        <div className="aai-accordions">
          <div className="accordion accordion-flush">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <div
                  name={id}
                  className="accordion-button flex-wrap"
                  type="button"
                  onClick={handleAccordion}
                  draggable={true}
                >
                  {!isMobile && (
                    <img src={svgs.draggable} alt="draggable" width={24} />
                  )}
                  <div
                    className={`chapter-title-section ${
                      isMobile ? "" : "pe-4"
                    }`}
                    style={{
                      cursor: "move",
                      marginRight: isMobile ? "1rem" : "unset",
                      color: "black",
                      flex: 1,
                      padding: 0,
                    }}
                  >
                    {title}
                  </div>

                  {/* Edit Action Button */}
                  {onEditToggle && (
                    <div className="chapter-actions">
                      <button
                        className="chapter-action-btn me-2"
                        onClick={onEditToggle}
                        title={t("edit")}
                      >
                        <img
                          src={editIcon}
                          alt="Edit"
                          width={24}
                          height={24}
                          className="action-icon"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </h2>
              <div
                id={id}
                className="accordion-collapse"
                style={{ position: "relative" }}
              >
                <div className="accordion-body" style={{ padding: "0px" }}>
                  {editMode ? (
                    <div>
                      <textarea
                        className="form-control shadow-none"
                        value={content}
                        onChange={onContentChange}
                        style={{
                          minHeight: "150px",
                          margin: "10px 0",
                        }}
                      />
                      <button
                        className="aai-btn btn-pill-solid"
                        onClick={onSave}
                      >
                        {saveLabel || t("save")}
                      </button>
                    </div>
                  ) : (
                    <div>{content}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionSection;
